// src/components/pages/backtest/utils/backtestUtils.js
import { BarChart2, List, AlertTriangle, Dice5 } from "lucide-react";

export const COLORS = {
  optimized: '#1f77b4',
  benchmark: '#4bf2a1ff',
  diff: '#ff7f0e'
};

export const CRISIS_SCENARIOS = [
    { id: 'asia_russia', label: 'backtest.crisis.asiaRussia', start: '1998-07-20', end: '1998-10-08' },
    { id: 'dotcom', label: 'backtest.crisis.dotcom', start: '2000-03-24', end: '2002-10-09' },
    { id: 'gfc', label: 'backtest.crisis.gfc', start: '2007-10-09', end: '2009-03-09' },
    { id: 'trade_war', label: 'backtest.crisis.tradeWar', start: '2018-09-20', end: '2018-12-25' },
    { id: 'covid', label: 'backtest.crisis.covid', start: '2020-02-19', end: '2020-03-23' },
    { id: 'inflation', label: 'backtest.crisis.inflation', start: '2022-01-03', end: '2022-10-12' },
];

export const generateColors = (count) => 
  Array.from({ length: count }, (_, i) => `hsl(${(i * 360) / count}, 70%, 50%)`);

export const getRollingConfig = (period) => {
  const map = { '1year': { suffix: '1Year', days: 251 }, '3year': { suffix: '3Year', days: 755 }, '5year': { suffix: '5Year', days: 1259 } };
  return map[period] || map['1year'];
};

export const calculateYRange = (chartData, xStart, xEnd) => {
  if (!chartData || !xStart || !xEnd) return undefined;
  let min = Infinity, max = -Infinity, hasData = false;

  chartData.forEach((trace) => {
    if (trace.visible === 'legendonly' || !trace.x || !trace.y) return;
    for (let i = 0; i < trace.x.length; i++) {
      const date = trace.x[i];
      if (date >= xStart && date <= xEnd) {
        const val = trace.y[i];
        if (typeof val === 'number') {
           if (val < min) min = val;
           if (val > max) max = val;
           hasData = true;
        }
      }
    }
  });

  if (!hasData || min === Infinity) return undefined;
  const padding = (max - min) * 0.05; 
  return padding === 0 ? [min - 0.1, max + 0.1] : [min - padding, max + padding];
};

export const reconstructMap = (dataArray, datesArray) => {
  if (!dataArray || !datesArray) return {};
  const result = {};
  datesArray.forEach((date, index) => {
    if (dataArray[index] !== undefined) result[date] = dataArray[index];
  });
  return result;
};
export const getCommonLayout = (title, xAxisTitle, yAxisTitle, isDate = true, yRange = null, isMobile = false, xRange = null) => {
  const base = {
    autosize: true,
    responsive: true,
    margin: { l: 50, r: 50, t: 50, b: 80 },
    legend: { orientation: "h", x: 0.5, xanchor: "center", y: 1.1 },
    xaxis: { 
      title: xAxisTitle, 
      type: isDate ? 'date' : 'category', 
      // xRange가 있으면 autorange를 끄고 range를 적용
      autorange: !xRange, 
      range: xRange, 
      rangeslider: { visible: true, bgcolor: "#f0f2f5", thickness: 0.05, yaxis: { visible: false } } 
    },
    // yaxis는 yRange 여부에 따라 결정
    yaxis: { title: yAxisTitle, fixedrange: false, autorange: !yRange, range: yRange },
    title: title
  };

  return isMobile 
    ? { ...base, dragmode: false, xaxis: { ...base.xaxis, fixedrange: true }, yaxis: { ...base.yaxis, fixedrange: true } }
    : { ...base, dragmode: 'pan' };
};

export const getOptimizationLinks = (t) => [
  { label: 'alloc', to: "/allocation", icon: <BarChart2 size={20} color="#6a1b9a"/>, title: t("backtest.allocTitle") || "황금비율 찾기", desc: t("backtest.allocDesc") },
  { label: 'corr', to: "/correlation", icon: <List size={20} color="#3b82f6"/>, title: t("backtest.corrTitle") || "종목 궁합 확인", desc: t("backtest.corrDesc") },
  { label: 'risk', to: "/risk", icon: <AlertTriangle size={20} color="#f59e0b"/>, title: t("backtest.riskTitle") || "손실 방패 만들기", desc: t("backtest.riskDesc") },
  { label: 'sim', to: "/simulation", icon: <Dice5 size={20} color="#ec4899"/>, title: t("backtest.simTitle") || "미래 수익 예측", desc: t("backtest.simDesc") },
];